import React from 'react'
import { factoryProviderInit } from './sdk/providers/factoryProvider/init'
import methods from './sdk/methods'

factoryProviderInit()

window.sfinanceSDK = methods

if (window.onLoadSFinanceSDK) window.onLoadSFinanceSDK()
